<template>
    <list-manager
        class="cigo-user"
        :dataUrl="'/userList'"
        :statusUrl="'/status/User'"
        :columns="columns"
        :columnsSlots="columnsSlots"
        :showPage="true"
        :showExportBtn="false"
        :showViewBtn="false"
        :showEditBtn="false"
    >
        <template v-slot:top-ctrl-left></template>
        <template v-slot:bottom-ctrl-left></template>
        <template v-slot:top-ctrl-right></template>
        <template v-slot:bottom-ctrl-right></template>
        <template v-slot:createTimeTpl="{record}">
            <span>{{record.create_time? dayjs.unix(record.create_time).format('YYYY-MM-DD HH:mm:ss') : ''}}</span>
        </template>
    </list-manager>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import dayjs from "dayjs";
import ListManager from "@/components/cigo-admin-core/pages/template/ListManager.vue";

export default defineComponent({
    name: "User",
    components: {
        ListManager
    },
    setup(props) {
        const columns = [
            {
                title: "编号",
                dataIndex: "id",
                width: "80px"
            },
            {
                title: "手机号",
                dataIndex: "phone",
                width: "150px"
            },
            {
                title: "注册时间",
                dataIndex: "create_time",
                width: "180px",
                slots: {
                    customRender: "createTime"
                }
            }
        ];
        let columnsSlots = [
            {
                slot: "createTime"
            }
        ];

        return {
            dayjs,
            columns,
            columnsSlots
        };
    }
});
</script>

<style lang="scss">
</style>
